export default "__VITE_ASSET__Clr9goSk__"